/**
 * @file live-checks.ts
 * @description Проверки публикации по данным магазина — то, без чего сайт
 * работает уже сейчас (phase19.16, SB125; партия SB120 этап 2 —
 * db-design-sb120-stage2 §6 `GET admin/site-view/live-issues`).
 *
 * Зачем в shared: один список кодов для сервера (ответ `live-issues` отдаёт
 * только эти ошибки уровня `error`) и кабинета (плашка «Сайт работает без…»
 * на «Сводке» и на главной). Проверки по данным магазина (реквизиты
 * продавца, правовые документы) одинаковы для черновика и для сайта, поэтому
 * только они честно говорят о живом сайте. Проверки черновика (шаблон
 * товара, колонки подвала и прочие) описывают ещё не опубликованное — им
 * место в окне публикации, не в плашке (решение оркестратора по ревью SB125).
 * Перенесено из apps/admin/src/lib/site-view/publish-acknowledge.ts.
 *
 * Коды — те, что выдаёт apps/api site-view-checks.service.ts; новый код
 * уровня магазина — новая запись здесь (OCP).
 */

/** Коды проверок по данным магазина в порядке показа. */
export const SHOP_LEVEL_CHECK_CODE_LIST = ["site_view_seller_incomplete", "site_view_legal_docs_missing"] as const;

export type ShopLevelCheckCode = (typeof SHOP_LEVEL_CHECK_CODE_LIST)[number];

/** Те же коды множеством — для фильтра списка проверок. */
export const SHOP_LEVEL_CHECK_CODES: ReadonlySet<string> = new Set<string>(SHOP_LEVEL_CHECK_CODE_LIST);

/** Код — проверка по данным магазина (видна на живом сайте). */
export function isShopLevelCheckCode(code: string): code is ShopLevelCheckCode {
  return SHOP_LEVEL_CHECK_CODES.has(code);
}
